import PaginationPanel from "./PaginationPanel"

export default PaginationPanel;